<template>
  <BaseDialog
    centered
    contentClass="edit-evaluation-grid-template"
    ref="dialog"
    persistent
    show-actions
    @closeModal="closeDialog"
  >
    <template #title>
      {{ dialogTitle }}
    </template>
    <template #content>
      <form @submit.prevent="onSubmit" class="edit-evaluation-grid-template__form" @keydown.enter="handleEnterPress">
        <div class="form-section">
          <FormInput
            ref="name"
            :label="$t('page.admin-evaluation-grid.name')"
            is-required
            has-gray-background
            name="name"
            type="text"
            v-model="name"
            v-validate="'required'"
          />
        </div>
        <div class="edit-evaluation-grid-template__actions">
          <FormButton is-outlined class="edit-evaluation-grid-template__cancel" @click.native="cancelClick">
            {{ $t('actions.cancel') }}
          </FormButton>
          <FormButton type="submit" :disabled="isFormInvalid">
            <span>{{ buttonText }}</span>
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import FormButton from '@/components/form/FormButton';
import FormInput from '@/components/form/FormInput.vue';
import { mapActions } from 'vuex';

export default {
  name: 'EditEvaluationGridTemplate',
  components: {
    BaseDialog,
    FormButton,
    FormInput,
  },
  props: {
    templateId: {
      type: String,
    },
    templateName: {
      type: String,
      default: '',
    },
    templateIsPrimary: {
      type: Boolean,
    },
  },
  data() {
    return {
      name: this.templateName || '',
    };
  },
  computed: {
    dialogTitle() {
      return this.$t('page.admin-evaluation-grid.edit-template');
    },
    buttonText() {
      return this.$t('actions.save');
    },
    isFormInvalid() {
      return !this.name;
    },
  },
  watch: {
    templateName(newVal) {
      this.name = newVal || '';
    },
  },
  methods: {
    ...mapActions('evaluationGridTemplates', ['editEvaluationGridTemplate']),
    openDialog() {
      this.name = this.templateName || '';
      this.$refs.dialog.openModal();
      this.$nextTick(() => {
        const refInput = this.$refs.name.$el.querySelector('input');
        if (refInput) {
          this.$nextTick(() => refInput.focus());
        }
      });
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    onSubmit() {
      if (!this.$refs.dialog.isModalOpen) return;
      if (this.isFormInvalid) {
        this.$toast.error(this.$t('errors.missingFields'));
        return;
      }
      this.editEvaluationGridTemplate({
        templateId: this.templateId,
        templateData: { name: this.name, isPrimary: this.templateIsPrimary },
      })
        .then(() => {
          this.$toast.success(this.$t('page.admin-evaluation-grid.toast.update-template-success'));
          this.$emit('action-succeeded');
          this.closeDialog();
        })
        .catch((error) => {
          this.$toast.error(error);
        });
    },
    cancelClick() {
      this.closeDialog();
    },
    handleEnterPress(event) {
      if (this.isFormInvalid) {
        event.preventDefault();
      } else {
        this.onSubmit();
      }
    },
  },
};
</script>

<style lang="scss">
.edit-evaluation-grid-template__form {
  .form-input {
    padding-bottom: 16px;
  }
  .edit-evaluation-grid-template__actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
  }
  .edit-evaluation-grid-template__cancel {
    margin-right: 12px;
  }
}
.base-dialog__edit-evaluation-grid-template {
  height: auto;
  width: 500px;
  position: relative;
  border-radius: $border-radius-root;

  .base-dialog__content {
    background: $color-white !important;
    padding: 32px !important;
  }
}
</style>
